import { Tournament, TournamentType } from '../models';
import { TournamentRepository } from '../repositories';
import { logger } from '@/src/core/utils';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class CreateTournamentUseCase {
  constructor(
    private tournamentRepository: TournamentRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(params: {
    name: string;
    description?: string;
    tournamentType: TournamentType;
    maxParticipants?: number;
    userId: string;
    isPublic?: boolean;
  }): Promise<Tournament> {
    const { name, description, tournamentType, maxParticipants, userId, isPublic } = params;

    logger.debug('CreateTournament', 'Creating tournament', { name, tournamentType, userId });

    if (!name.trim()) {
      throw new Error('Tournament name is required');
    }

    // Moderate content before writing
    await this.moderateContent.execute(name, 'tournament_name', userId);
    if (description) {
      await this.moderateContent.execute(description, 'tournament_description', userId);
    }

    const tournamentData = {
      name: name.trim(),
      description: description?.trim(),
      tournamentType,
      maxParticipants,
      status: 'setup' as const,
      userId,
      isPublic: isPublic ?? false,
    };

    logger.debug('CreateTournament', 'Tournament data prepared', { name: tournamentData.name, tournamentType: tournamentData.tournamentType });

    const tournament = await this.tournamentRepository.create(tournamentData);

    logger.info('CreateTournament', 'Tournament created', { tournamentId: tournament.id });

    return tournament;
  }
}
